import React from 'react';
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const BreadCrumbItem = (props) => {
    let history = useNavigate();
    const { i18n } = useTranslation();
    const handleClick = (e,l) => {
        e.preventDefault()
        history("/"+i18n.language+ l)
    }


    return (
        <a className="new-breadcrumb-item" onClick={e=>handleClick(e, props.item.link)}>{i18n.t(props.item.name)}<FontAwesomeIcon className={"mx-1"} icon={['fas', 'angle-right']} /></a>
    );
};

export default BreadCrumbItem;
